import React, { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import moment from 'moment';
import numeral from 'numeral';
import {
  Avatar,
  Box,
  Card,
  CardMedia,
  Divider,
  Grid,
  IconButton,
  Link,
  SvgIcon,
  Tooltip,
  Typography,
  colors,
  makeStyles
} from '@material-ui/core';
import { Rating } from '@material-ui/lab';
import FavoriteIcon from '@material-ui/icons/Favorite';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import { Users as UsersIcon } from 'react-feather';
import { MessageSquare } from 'react-feather';
import getInitials from 'src/utils/getInitials';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import DOMPurify from 'dompurify';
import Reactions from './ThreadCard/Reactions';
import { useLocation } from 'react-router-dom';
import ReportIcon from '@mui/icons-material/Report';
import { CardHeader, Menu, MenuItem, Stack } from '@mui/material';
import { MoreVert } from '@mui/icons-material';
import ReportModal from './modal/ReportModal';

import SocialShare from 'src/components/SocialShare';
import { DOMAIN_NAME } from 'src/utils/helper';

const useStyles = makeStyles((theme) => ({
  root: {},
  image: {
    height: 200,
    backgroundColor: theme.palette.background.dark
  },
  likedButton: {
    color: colors.red[600]
  },
  membersIcon: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(1)
  }
}));

const ProjectCard = ({ className, thread,page, ...rest }) => {
  // console.log('thread',thread);
  const [filterTag,setFilterTag]=useState('');
  const [modalOpen,setModalOpen]=useState(false);
  const classes = useStyles();
  const {exam_slug}=useParams();
  const location = useLocation();
  
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const tagValue = queryParams.get('tag');
    if(tagValue){
      setFilterTag(tagValue);
    }else{
      setFilterTag('')
    }
  }, [location.search]); 
  
  const HTMLRenderer = ({ htmlContent }) => {
    const sanitizedHTML = DOMPurify.sanitize(htmlContent);
    return (
      <div  dangerouslySetInnerHTML={{ __html: sanitizedHTML }} />
    );
  };

  return (
    <Card
      style={{ marginBottom: '-16px'}}  
      className={clsx(classes.root, className)}
      {...rest}
    >
      <ReportModal modalOpen={modalOpen} setModalOpen={setModalOpen} reportedItem={thread._id} itemType={'threads'}/>
      <Box p={2}
      display="flex"
      justifyContent="space-between"
      >
        <Box
          display="flex"
          alignItems="center"
        >
          <Avatar
            alt={(thread&&thread.userId&&thread.userId.firstname)?thread.userId.firstname:""}
            src={(thread&&thread.userId&&thread.userId.profilePicture)?thread.userId.profilePicture:''}
            component={RouterLink}
            to={`/${exam_slug}/app/social/profile/${thread.userId?thread.userId._id:''}`}
          >
            {getInitials((thread&&thread.userId&&thread.userId.firstname)?thread.userId.firstname:'')}
          </Avatar>          
          <Box ml={2}>   
            <Link
              color="textPrimary"
              component={RouterLink}
              to={`/${exam_slug}/app/threads/${thread._id}?tag=${filterTag}&page=${page}`}
              variant="h5"
            >
              {/* {thread.title} */}            
             <b>
                {/* <HTMLRenderer htmlContent={(thread.title&& thread.title.length>25) ?thread.title.slice(0,25)+"...":thread.title} /> */}
                <HTMLRenderer htmlContent={thread.title??''} />
              </b>
            </Link>
            <Typography
              variant="body2"
              color="textSecondary"
            >
              by
              {' '}
              <Link
                color="textPrimary"
                // component="span"                
                variant="h6"
                component={RouterLink}
                to={`/${exam_slug}/app/social/profile/${thread.userId?thread.userId._id:''}`}
              >
                {(thread&&thread.userId&&thread.userId.firstname)?thread.userId.firstname:""} {(thread&&thread.userId&&thread.userId.lastname)?thread.userId.lastname:""}
              </Link>
              {' '}
              | Updated
              {' '}
              {moment(thread.updatedAt).fromNow()}
              
            </Typography>
          </Box>
        </Box>
        
      </Box>
      <Box
        pb={1}
        px={3}
      >
        <Typography
          color="textSecondary"
          variant="body2"
        >
          <b style={{ color: 'black' }}>
            <HTMLRenderer htmlContent={(thread.description&& thread.description.length>240) ?thread.description.slice(0,240).trim()+`...<a href='/${exam_slug}/app/threads/${thread._id}?tag=${filterTag}&page=${page}'>(More)</a>`:thread.description} />
          </b>
        </Typography>        
      </Box>
      <Stack direction={'row'} justifyContent={'flex-end'} spacing={3} mr={2} mb={1}>
        <Tooltip title="Report Abuse">
            <IconButton
            size="small"
            onClick={()=>setModalOpen(true)}
            >
                <ReportIcon/>
              <small style={{fontSize:"12px"}}>Report</small>
            </IconButton>
        </Tooltip>  
        <Tooltip title="Share">
            <SocialShare 
            shareUrl={`community.${DOMAIN_NAME}/${exam_slug}/app/threads/${thread._id}?tag=&page=1`}
            title={thread.desc}
            />
        </Tooltip>              
      </Stack> 
      <Divider />
      <Box
        py={0}
        pl={0}
        pr={0}
        display="flex"
        alignItems="center"
      >
        <Reactions thread={thread}/>        
        <SvgIcon
          fontSize="small"
          color="action"
          className={classes.membersIcon}
        >
          <MessageSquare />
        </SvgIcon>
        <Typography
          variant="subtitle2"
          color="textSecondary"
        >
          {thread.ThreadReply.length}
        </Typography>
        <Box flexGrow={1} />
        
      </Box>
      
    </Card>
  );
};

ProjectCard.propTypes = {
  className: PropTypes.string,
  project: PropTypes.object.isRequired
};

export default ProjectCard;
